import React, { useEffect, useState, useRef } from 'react';
import { getBaseDir, apiCall } from '../../utils';
import moment from 'moment-timezone';

const BankReconciliationHead = ({
    isLoading = false,
    updateHeadData,
    bodyData,
    setMainFinancialAccountData,
    handleOpenEditBalanceModal
}) => {
  const [financialAccountData, setFinancialAccountData] = useState(null);
  const [isLoadingFinancialAccountData, setIsLoadingFinancialAccountData] = useState(false);
  const apiCallXhr = useRef(null);
  const hasInitializedSelectors = useRef(false);
  const initData = () => {
    if (hasInitializedSelectors.current) return;
    hasInitializedSelectors.current = true;
    $(document).ready(function() {
      let headData = JSON.parse(localStorage.getItem('bankReconciliationHeadData'));
      if (!headData) {
        headData = {
          branchId: null,
          financialAccount: null,
          dateRange: null
        };
      }

      // Detecta seleção de data no date ranger picker do dashboard marketing
      $('input[name="daterange"]').daterangepicker({
        opens: 'left',
        startDate: headData.dateRange ? moment(headData.dateRange.split('|')[0]) : moment().startOf('day'),
        endDate: headData.dateRange ? moment(headData.dateRange.split('|')[1]) : moment().endOf('day'),
        opens: "right",
        drops: "down",
        locale: window._sessionData.i8nDateRangePicker, 
        ranges: {
          'Hoje': [moment().startOf('day'), moment().endOf('day')],
          'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Amanhã': [moment().add(1, 'days'), moment().add(1, 'days')],
          'Últimos 7 Dias': [moment().subtract(6, 'days'), moment()],
          'Últimos 30 Dias': [moment().subtract(29, 'days'), moment()],
          'Este Mês': [moment().startOf('month'), moment().endOf('month')],
          'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        },
      }, function(start, end, label) {
        updateHeadData({
          dateRange: `${start.format('YYYY-MM-DD 00:00:00.000')}|${end.format('YYYY-MM-DD 00:00:00.000')}`
        });
        //console.log("A new date selection was made: " + start.format('YYYY-MM-DD 00:00:00.000') + ' to ' + end.format('YYYY-MM-DD 00:00:00.000'));
        /*self.periods['DASHBOARD'] = `${start.format('YYYY-MM-DD 00:00:00.000')}|${end.format('YYYY-MM-DD 00:00:00.000')}`;
        self.loadMarketingMetrics(false)
        .then(() => {
            console.log('rerender loadMarketingMetrics report')
        })
        .then(() => {
            self.loadMarketingLastLeads(false)
            self.loadMarketingGeneralFunnel(false)
            self.loadMarketingPerSellerFunnel(false)
            self.loadMarketingLeadsHistoryChart(false)
            self.loadMarketingKPIs(false)
        });*/
      });
    });

    $('select[name="financial_account_id"]').select2({
      placeholder: "Selecione uma conta financeira",
      theme: 'bootstrap-5',
      dropdownParent: $(".js-bank-reconciliation-head"),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/financial/accounts',
        delay: 1000,
        data: function(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function(data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.results, function(k, v) {
            results.push({
              id: v.ID,
              text: v.CONTA,
              info: v
            });
          });

          // Transforms the top-level key of the response object from 'items' to 'results'
        return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    $('select[name="financial_account_id"]').on('select2:select', function(e) {
      //console.log('change', e.params.data);
      let headData = JSON.parse(localStorage.getItem('bankReconciliationHeadData'));
      if (!e.params) {
        updateHeadData({
          financialAccount: headData.financialAccount
        });
      } else {
        updateHeadData({
          financialAccount: e.params.data
        });
      }
      onSelect2Change();
    });

    $('.js-bank-reconciliation-head-branches-selector').select2({
      placeholder: "Selecione uma filial",
      theme: 'bootstrap-5',
      dropdownParent: $(".js-bank-reconciliation-head-branches-selector-container")
    });

    $('.js-bank-reconciliation-head-branches-selector').on('select2:select', function(e) {
      if (!e.params) {
        let headData = JSON.parse(localStorage.getItem('bankReconciliationHeadData'));
        localStorage.setItem('outerBTPSelectedBranch', headData.branchId);
        updateHeadData({
          branchId: headData.branchId,
          branchName: headData.branchName
        });
        $('#insert_btp_branch_id').val(headData.branchId)
      } else {
        localStorage.setItem('outerBTPSelectedBranch', e.params.data.id);
        updateHeadData({
          branchId: e.params.data.id,
          branchName: e.params.data.text
        });
        $('#insert_btp_branch_id').val(e.params.data.id)
      }
      onSelect2Change();
    });
  }

  const onSelect2Change = (e) => {
    //console.log('onSelect2Change', e);
    let headData = JSON.parse(localStorage.getItem('bankReconciliationHeadData'));
    if (headData?.branchId && headData?.financialAccount && !isLoadingFinancialAccountData) {
      if (apiCallXhr.current) {
        apiCallXhr.current.abort();
      }
      $('.BankReconciliationTabsContent').block(window._loader.loading);
      setIsLoadingFinancialAccountData(true);
      apiCallXhr.current = apiCall({
        method: 'GET',
        endpoint: 'api/v1/financial/account',
        data: {
          branchId: headData.branchId,
          accountId: headData.financialAccount.id,
          startDate: headData.dateRange ? headData.dateRange.split('|')[0] : moment().startOf('month').format('YYYY-MM-DD'),
          endDate: headData.dateRange ? headData.dateRange.split('|')[1] : moment().endOf('month').format('YYYY-MM-DD')
        },
        successCallback: function(res) {
          //console.log('success', res);
          if (!res.error) {
            setFinancialAccountData(res.data);
            setMainFinancialAccountData(res.data);
          }
          setIsLoadingFinancialAccountData(false);
          $('.BankReconciliationTabsContent').unblock();
        },
        errorCallback: function(res) {
          console.log('error', res);
          setIsLoadingFinancialAccountData(false);
          $('.BankReconciliationTabsContent').unblock();
        }
      });
    }
  }

  React.useEffect(() => {
    initData();
    //console.log('initData');
  }, []);

  React.useEffect(() => {
    onSelect2Change();
  }, [bodyData]);

  /*console.log('============================================== RENDER BANK RECONCILIATION HEAD ==============================================');
  console.log('isLoading', isLoading);
  console.log('financialAccountData', financialAccountData);
  console.log('isLoadingFinancialAccountData', isLoadingFinancialAccountData);
  console.log('bodyData', bodyData);*/
  
  return (
    <div className="col-sm-12">
      <div className="mb-3 card">
        <div className="col-12 p-2">
          <div className="row mb-3">
            <div className="col-12 mb-3">
              <div className="form-group mt-3 js-bank-reconciliation-head-branches-selector-container">
                <label>Filial</label>
                <select id="cityFilter" className="form-select js-business-branches-selector-type-3 js-bank-reconciliation-head-branches-selector"></select>
              </div>
            </div>
            <div className="col-sm-12 col-md-3 col-lg-3 js-bank-reconciliation-head mb-3">
              <select className="form-select" name="financial_account_id"></select>
            </div>
            <div className="col-sm-12 col-md-3 col-lg-3 mb-3">
              <div className="dropdown w-100">
                <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownBankActions" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Ações da conta
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownBankActions">
                  <a className="dropdown-item js-bank-reconciliation-head-edit-balance" href="#">Editar saldo da conta</a>
                  <a className="dropdown-item js-bank-reconciliation-head-import-ofx" href="#">Importar extrato (.OFX)</a>
                  <a className="dropdown-item" href="#">Lançamentos ignorados</a>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-3 offset-md-3 mb-3">
              <input type="text" className="form-control" name="daterange" id="bank-reconciliation-head-daterange" />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-12 col-md-5">
              Data de última atualização:<br /><span className="fw-bold">00/00/0000 00:00</span>
            </div>
            <div className="col-sm-12 col-md-2 offset-md-2">
              Saldo atual:<br /><span className="fw-bold">R$ {financialAccountData?.balance_conciliated_or_ignored ?? '0,00'}</span>
            </div>
            <div className="col-sm-12 col-md-3">
              Valor pendente de conciliação:<br /><span className="fw-bold">R$ {financialAccountData?.balance_not_conciliated ?? '0,00'}</span>
            </div>
            <div className="col-sm-12">
              Data do último lançamento importado:<br /><span className="fw-bold">{financialAccountData?.last_import_bank_statement ?? 'Não há lançamentos importados'}</span>	
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default BankReconciliationHead;